<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="12" style="padding-bottom: 24px">
        <div class="titulo negrito cor-fonte fonte-primaria">
          Serviços Prestados
        </div>
      </unicom-coluna>
    </unicom-linha>

    <centro-oncologia-componente
      v-if="objetoServicos['Centro de Oncologia'].ativo"
      :dadosServidor="this.dadosServidorServ"
      :servico="objetoServicos['Centro de Oncologia']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
      @error="errorHandler"
    ></centro-oncologia-componente>

    <centro-multidisciplinar-componente
      v-if="objetoServicos['Centro Multidisciplinar'].ativo"
      :dadosServidor="this.dadosServidorServ"
      :servico="objetoServicos['Centro Multidisciplinar']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
      @error="errorHandler"
    ></centro-multidisciplinar-componente>

    <centro-hemodialise-componente
      v-if="objetoServicos['Centro de Hemodiálise'].ativo"
      :dadosServidor="this.dadosServidorServ"
      :servico="objetoServicos['Centro de Hemodiálise']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
      @error="errorHandler"
    ></centro-hemodialise-componente>

    <centro-hemodinamica-componente
      v-if="objetoServicos['Centro de Hemodinâmica'].ativo"
      :dadosServidor="this.dadosServidorServ"
      :servico="objetoServicos['Centro de Hemodinâmica']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
      @error="errorHandler"
    ></centro-hemodinamica-componente>

    <espaco-viver-bem-componente
      v-if="objetoServicos['Espaço Viver Bem'].ativo"
      :dadosServidor="this.dadosServidorServ"
      :servico="objetoServicos['Espaço Viver Bem']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
      @error="errorHandler"
    ></espaco-viver-bem-componente>

    <centro-vacinacao-componente
      v-if="objetoServicos['Centro de Vacinação'].ativo"
      :dadosServidor="this.dadosServidorServ"
      :servico="objetoServicos['Centro de Vacinação']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
      @error="errorHandler"
    ></centro-vacinacao-componente>

    <atencao-primaria-saude-componente
      v-if="objetoServicos['Atenção Primária à Saúde'].ativo"
      :dadosServidor="this.dadosServidorServ"
      :servico="objetoServicos['Atenção Primária à Saúde']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
      @error="errorHandler"
    ></atencao-primaria-saude-componente>

    <centro-terapias-especiais-componente
      v-if="objetoServicos['Centro de Terapias Especiais'].ativo"
      :dadosServidor="this.dadosServidorServ"
      :servico="objetoServicos['Centro de Terapias Especiais']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
      @error="errorHandler"
    ></centro-terapias-especiais-componente>

    <outros-servicos-componente
      v-if="objetoServicos['Outros'].ativo"
      :dadosServidor="this.dadosServidorServ"
      :servico="objetoServicos['Outros']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
      @error="errorHandler"
    ></outros-servicos-componente>
  </unicom-layout-cartao>
</template>

<script>
import ServicosMixin from "@/views/RecursosPropriosQuestionarios/Clinica/componentes/CartaoInformacoesServicos/ServicosMixin";

import AtencaoPrimariaSaudeComponente from "./components/AtencaoPrimariaSaudeComponente.vue";
import CentroHemodialiseComponente from "./components/CentroHemodialiseComponente.vue";
import CentroHemodinamicaComponente from "./components/CentroHemodinamicaComponente.vue";
import CentroMultidisciplinarComponente from "./components/CentroMultidisciplinarComponente.vue";
import CentroOncologiaComponente from "./components/CentroOncologiaComponente.vue";
import CentroTerapiasEspeciaisComponente from "./components/CentroTerapiasEspeciaisComponente.vue";
import CentroVacinacaoComponente from "./components/CentroVacinacaoComponente.vue";
import EspacoViverBemComponente from "./components/EspacoViverBemComponente.vue";
import OutrosServicosComponente from "./components/OutrosServicosComponente.vue";
import MixinValidacoes from "@/views/RecursosPropriosQuestionarios/shared/mixins/validation/MixinValidacoesQuestionario";

export default {
  mixins: [ServicosMixin, MixinValidacoes],
  components: {
    AtencaoPrimariaSaudeComponente,
    CentroHemodialiseComponente,
    CentroHemodinamicaComponente,
    CentroMultidisciplinarComponente,
    CentroOncologiaComponente,
    CentroTerapiasEspeciaisComponente,
    CentroVacinacaoComponente,
    EspacoViverBemComponente,
    OutrosServicosComponente
  },
  data() {
    return {};
  },
  methods: {
    prepararPayloadServicos(payloadDoComponente) {
      if (!payloadDoComponente) return;

      this.objetoServicos[payloadDoComponente.tipoServico].payload = {
        ...payloadDoComponente
      };

      if (payloadDoComponente.clickSwitch) {
        this.objetoServicos[payloadDoComponente.tipoServico].preenchido = true;
      }

      this.preparaDadosServicos();
    },
    switchHandler(payload) {
      this.objetoServicos[payload.tipoServico].preenchido = payload.clickSwitch;

      if (!payload.clickSwitch) {
        this.payloadServicos = this.payloadServicos.filter(
          servico => servico.tipoServico.tipoServico !== payload.tipoServico
        );
        this.payloadEspecialidades = this.payloadEspecialidades.filter(
          espe => espe.tipoServico.tipoServico !== payload.tipoServico
        );
        this.payloadAbrancencias = this.payloadAbrancencias.filter(
          abran => abran.tipoServico.tipoServico !== payload.tipoServico
        );
        this.payloadServicosPublicos = this.payloadServicosPublicos.filter(
          servPubl => servPubl.tipoServico.tipoServico !== payload.tipoServico
        );
      }

      this.preparaDadosServicos();

      this.$emit("payload-atualizado", {
        servicos: [...this.payloadServicos],
        especialidades: [...this.payloadEspecialidades],
        abrangencias: this.payloadAbrancencias,
        servicosPublicos: this.payloadServicosPublicos
      });
    }
  }
};
</script>

<style scoped>
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
</style>
